import { useQuery } from "react-query";

import { getEmployes } from "../../../../../MyApi/sb/employes";

import Select from "react-select";
import LoadingSpinner from "../../../../UI/spinner";
import icons from "../../../../../Data/icons";

import classes from "./addAttendance.module.css";
import { useTranslation } from "react-i18next";

const AddAttendance = ({  setQ, employId, setEmployId ,setDate ,setTime }) => {
  const { data, isLoading } = useQuery(["getEmployes", 1], () =>
    getEmployes(1)
  );
  const {t}=useTranslation()

  const StatusIcon = icons.status;
  const DateIcon =icons.date
  const TimeIcon = icons.timer

  const handelStatusChange = (e) => {
    setQ(e.target.value);
  };
  const handelEmployChange = (selectedOption) => {
    const employID = selectedOption ? selectedOption.id : 0;
    setEmployId(employID);
  };
  const handelDateChange =(e)=>{
    const {value}=e.target
    setDate(value)
  }
  const handelTimeChange =(e)=>{
    const {value}=e.target
    setTime(value)
  }

  if (isLoading) {
    return <LoadingSpinner />;
  }
  const employes = data?.data || [];

  return (
    <div className={classes.formCard}>

      <div className={classes.formGrid}>
        <div className={classes.formCol}>
          <label htmlFor="">{t("Status")} </label>
          <div className={classes.iconInput}>
            <StatusIcon />
          </div>
          <select
            type="text"
            placeholder="ادخل الحالة "
            onChange={handelStatusChange}
            className={classes.inputCustom}>
            <option value="">ادخل الحالة</option>
            <option value="in">in</option>
            <option value="out">out</option>
            <option value="break">break</option>
            <option value="stop-break">stop-break</option>
          </select>
        </div>
        <div className={classes.formCol}>
          <label htmlFor="">{t("Employe")} </label>
          {!data ? (
            <div> no data available </div>
          ) : (
            <Select
              options={employes}
              getOptionValue={(e) => e.id}
              getOptionLabel={(e) => e.name_ar}
              onChange={handelEmployChange}
            />
          )}
        </div>
        <div className={classes.formCol}> 
          <label htmlFor="">{t("Time")}</label>
          <div className={classes.iconInput}>
            <TimeIcon />
          </div>
         <input type="time" className={classes.inputCustom} onChange={handelTimeChange} />
        </div>
        <div className={classes.formCol}> 
          <label htmlFor="">{t("Date")}</label>
          <div className={classes.iconInput}>
            <DateIcon />
          </div>
         <input type="date" className={classes.inputCustom} onChange={handelDateChange}/>
        </div>
      </div>
    </div>
  );
};

export default AddAttendance;
